export default "__VITE_ASSET__8eeb161e__"